module.exports = __webpack_public_path__ + "img/logo.fbc467f7.png";